export const SECTIONS = {
    BASE_SECTION  : 'summaries',
    CATEGORIES    : 'categories',
    SPECIALTIES   : 'specialties',
    ORGANIZATIONS : 'authoringOrganizations',
    PROFESSIONS   : 'professions',
    SUMMARIES     : 'summaries',
    SUMMARY       : 'summary',
    ORGANIZATION  : 'organization',
    CATEGORY      : 'category',
    SPECIALTY     : 'specialty',
    PROFESSION    : 'profession',
    SEARCH        : 'search',
    DEFAULT       : {
        SECTION : 'category',
        TITLE   : 'Assessment of Therapeutic Effectiveness',
        SUMMARY : 'Risk reduction of prostate cancer with drugs or nutritional supplements'
    }
};